import { useOutletContext } from "react-router";
import GitSettings from "../../components/template-modules/GitSettings";
import { IResourceDetails } from "../../types";


const ResourceSettingsGit = () => {
    const { resourceDetails } = useOutletContext<{ resourceDetails: IResourceDetails }>();

    return (
        <GitSettings pipelineId={resourceDetails.pipelineId} />
    );
}

export default ResourceSettingsGit;